var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNotifications = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 42,
  height: 42,
  viewBox: "0 0 42 42"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M21 4.626q1.092 0 1.869.777c.777.777.777 1.141.777 1.869v.818q3.696.924 5.796 4.032 2.058 2.982 2.058 7.056v8.694l3.528 3.528v1.722H6.972V31.8l3.528-3.528v-8.694q0-4.116 2.058-7.098 2.1-3.066 5.838-3.99V7.272q0-1.092.756-1.869A2.48 2.48 0 0 1 21 4.626m0 34.146q-1.428 0-2.478-1.008t-1.05-2.436h7.056q0 1.428-1.05 2.436T21 38.772"
})));
export default SvgNotifications;